<template>
    <page>
        <module title="秒杀活动详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="活动名称">{{activityInfo.activity_name}}</c-detail-item>
                    <c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>
                    <c-detail-item label="活动标签">{{activityInfo.tags}}</c-detail-item>
					<c-detail-item label="活动预告设置">{{activitynoticeText}}</c-detail-item>
					<c-detail-item label="下单未支付时">{{autoCancelText}}</c-detail-item>
                    <c-detail-item label="活动说明" full>{{activityInfo.activity_remark}}</c-detail-item>
                    <c-detail-item label="活动商品" full>
                        <c-table v-model="productList" height="auto" border>

                            <c-table-column
                                    label="商品信息"
                                    name="product_name"
                                    width="250"
                            >
                                <template v-slot="{data}">
                                    <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name" image-size="60"></product-info>
                                    <product-info v-else :image="data.product_img_url" :name="data.product_name" image-size="60"></product-info>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="价格"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动库存（单SKU）"
                                    name="activity_stock_count"
                                    width="120"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="活动销量"
                                    name="activity_sale_count"
                                    width="100"
                            >
                            </c-table-column>

                            <c-table-column
                                label="活动折扣"
                                width="140"
                                name="activity_discount"
                            >
                              <template v-slot="{data}">
                                <span v-if="data.activity_discount">{{ data.activity_discount }}折</span>
                              </template>
                            </c-table-column>

                            <c-table-column
                                label="促销价"
                                name="promotion_price"
                                width="80"
                            >
                            <template v-slot="{data}">
                                    <span v-if="data.activity_discount">
                                     ￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
                                      <span v-if="data.product_price_max">
                                          - ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
                                      </span>
                                    </span>
                            </template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'activity_secondkill_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                activityInfo: '',
                productList: [],
				autoCancelText: '',
				activitynoticeText: '',
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            },
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySecondkill/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.productList = data.product_list;
						
						if(data.auto_cancel == 1){
							this.autoCancelText = '按照指定时长（'+data.cancel_time+'分钟）自动取消订单';
						}else if(data.auto_cancel == 0){
							this.autoCancelText = '按系统配置自动取消';
						}
						
						if(data.activity_notice == 1){
							this.activitynoticeText = '提前（'+data.activity_notice_time+'分钟）预告活动';
						}else if(data.activity_notice == 0){
							this.activitynoticeText = '立即预告';
						}else if(data.activity_notice == -1){
							this.activitynoticeText = '不预告';
						}
                    }
                });
			}
        }
    }
</script>